import { useForm } from 'react-hook-form';
import InputField from '../../../../components/generic/InputField/InputField';
import { Button } from '../../../../components';

type AddCommentaryFormProps = {
  onSubmit: (data: any, isDirty: boolean) => void;
  onDelete?: () => void;
  data?: any;
};

const AddCommentaryForm = ({ onSubmit, data }: AddCommentaryFormProps) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      summary: data || '',
    },
  });

  return (
    <form onSubmit={handleSubmit((data) => onSubmit(data, isDirty))}>
      <InputField
        type="textArea"
        label="Commentary"
        name="summary"
        register={register}
        control={control}
        spaceBetween
      />
      <div className="flex justify-center mt-4">
        <Button className="primary-button w-[188px]" htmlType="submit">
          Save
        </Button>
      </div>
    </form>
  );
};

export default AddCommentaryForm;
